import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './ForgotPassword.css';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const { resetPassword } = useAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setMessage('');
            setError('');
            setLoading(true);
            await resetPassword(email);
            setMessage('Check your inbox for further instructions.');
        } catch (err) {
            switch (err.code) {
                case 'auth/user-not-found':
                    setError('No account found with this email address.');
                    break;
                case 'auth/invalid-email':
                    setError('The email address is not valid.');
                    break;
                default:
                    setError('Failed to reset password. Please try again.');
                    break;
            }
        }
        setLoading(false);
    };

    return (
        <>
            <title>Reset Password - WizeHelper</title>
            <div className="forgot-password-container" data-testid="forgotPassword-container">
                <div className="forgot-password-card" data-testid="forgotPassword-card">
                    <h1 className="forgot-password-title" data-testid="forgotPassword-title">Reset Password</h1>

                    {error && <p className="error-message" data-testid="forgotPassword-errorMessage">{error}</p>}
                    {message && <p className="wize-success-message" data-testid="forgotPassword-successMessage">{message}</p>}

                    <form onSubmit={handleSubmit} className="forgot-password-form" data-testid="forgotPassword-form">
                        <div className="form-group">
                            <label htmlFor="email">Email Address</label>
                            <input
                                type="email"
                                id="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="your.email@example.com"
                                required
                                autoComplete="email"
                                data-testid="forgotPassword-emailInput"
                            />
                        </div>
                        <button type="submit" className="submit-button" disabled={loading} data-testid="forgotPassword-submitButton">
                            {loading ? 'Sending...' : 'Reset Password'}
                        </button>
                    </form>

                    <div className="switch-form-link">
                        <p><Link to="/signin" data-testid="forgotPassword-signInLink">Back to Sign In</Link></p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ForgotPassword;
